import Anchor from "components/Anchor";
import type { AnchorProps } from "components/Anchor";
import type { ReactStoryblokComponent } from "types/storyblok";

const AnchorAdapter = ({ blok: { id }, sbEditable }: ReactStoryblokComponent<AnchorProps>) => (
  <Anchor id={id} sbEditable={sbEditable} />
);

export default AnchorAdapter;
